export const profilePageHeaderStyles = {
	headerRow: {
		display: 'contents'
	},

	typeLabel: {
		gridColumn: 1,
		alignSelf: 'center',
		color: 'text.secondary',
		fontSize: '0.75rem',
		minWidth: 0
	},

	headerActions: {
		gridColumn: 2,
		alignSelf: 'center',
		justifySelf: 'end',
		display: 'flex',
		alignItems: 'center',
		gap: 1.5
	}
};
